/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENTS_TAB = "ALL_COMMENTS" | "FEATURED_COMMENTS" | "NONE" | "QUESTIONS" | "REVIEWS" | "UNANSWERED_COMMENTS" | "%future added value";
export type AddACommentButtonLocal = {
    readonly loadAllButtonHasBeenClicked: boolean | null;
    readonly commentsFullyLoaded: boolean | null;
    readonly commentsTab: COMMENTS_TAB;
    readonly " $refType": "AddACommentButtonLocal";
};
export type AddACommentButtonLocal$data = AddACommentButtonLocal;
export type AddACommentButtonLocal$key = {
    readonly " $data"?: AddACommentButtonLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AddACommentButtonLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddACommentButtonLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "loadAllButtonHasBeenClicked",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsFullyLoaded",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsTab",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '1fb7ad25d0480356f22fec158b9c7595';
export default node;
